// extracted by mini-css-extract-plugin
export var cell = "about-module--cell--rvvXT";
export var cellSign = "about-module--cellSign--imLaj";
export var cellSw = "about-module--cellSw--qHh9Q";
export var check = "about-module--check--fCgrP";
export var content = "about-module--content--omyyq";
export var imgWrapper = "about-module--img-wrapper--w40ng";
export var memberSticky = "about-module--member-sticky--Isnq2";